import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getGeo } from "../lib/geo";
import { trackEvent, isInternalTraffic } from "../lib/track";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getId = (storage, key) => {
  let id = storage.getItem(key);
  if (!id) {
    id = `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    storage.setItem(key, id);
  }
  return id;
};

const basePayload = () => ({
  visitor_id: getId(localStorage, "ahjin_visitor_id"),
  session_id: getId(sessionStorage, "ahjin_session_id"),
});

const AnalyticsTracker = () => {
  const location = useLocation();
  const pathRef = useRef(location.pathname);
  pathRef.current = location.pathname;

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href*="wa.me"]');
      if (a) trackEvent("whatsapp", a.getAttribute("data-testid") || "");
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith("/admin") || isInternalTraffic()) return;
    getGeo().then((geo) => {
      axios
        .post(`${API}/track`, {
          ...basePayload(),
          path: location.pathname,
          referrer: document.referrer || null,
          event: "view",
          country: geo.country,
          city: geo.city,
          region: geo.region,
        })
        .catch(() => {});
    });
  }, [location.pathname]);

  useEffect(() => {
    const ping = () => {
      if (document.visibilityState !== "visible") return;
      if (pathRef.current.startsWith("/admin") || isInternalTraffic()) return;
      axios
        .post(`${API}/track`, { ...basePayload(), path: pathRef.current, event: "ping" })
        .catch(() => {});
    };
    const iv = setInterval(ping, 30000);

    const onLeave = () => {
      if (pathRef.current.startsWith("/admin") || isInternalTraffic()) return;
      try {
        const blob = new Blob(
          [JSON.stringify({ ...basePayload(), path: pathRef.current, event: "exit" })],
          { type: "application/json" }
        );
        navigator.sendBeacon(`${API}/track`, blob);
      } catch (e) {
        console.debug("[analytics] exit beacon skipped:", e?.message || e);
      }
    };
    window.addEventListener("pagehide", onLeave);
    return () => {
      clearInterval(iv);
      window.removeEventListener("pagehide", onLeave);
    };
  }, []);

  return null;
};

export default AnalyticsTracker;
